"use strict";

exports.__esModule = true;
exports.CmsClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _constants = require("../constants");
const CmsClient = {
  /**
   * fetch wallet FAQ
   * @param payload
   * @returns {Promise<unknown>}
   */
  fetch(payload) {
    const requestId = 'CMS_DATA';
    const endPoint = _constants.ENDPOINTS.CMS_PAGE;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(({
      data
    }) => data);
  }
};
exports.CmsClient = CmsClient;